import PropTypes from 'prop-types';

export const history = {
  action: PropTypes.string,
  back: PropTypes.func,
  go: PropTypes.func,
  goForward: PropTypes.func,
  goBack: PropTypes.func,
  push: PropTypes.func,
  repalce: PropTypes.func,
};

export const location = {
  hash: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
};

export const match = {
  isExact: PropTypes.bool,
  params: PropTypes.object,
  path: PropTypes.string,
  url: PropTypes.string,
};

export const auth = {
  displayName: PropTypes.string,
  email: PropTypes.string,
  emailverified: PropTypes.bool,
  use: PropTypes.bool,
  processing: PropTypes.string,
};

export default {
  history,
  location,
  match,
  auth,
};
